import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/dashboard/admin/faq/")({
  beforeLoad: () => {
    throw redirect({ to: "/dashboard/admin/content", search: { tab: "faq" } });
  },
});
